import { Slide } from "@material-ui/core";

const TRANSITION_TIMEOUT: number = 500;

type Param = {
    show: boolean,
    className?: string
}

const TransitionSlide: React.FC<Param> = ({ show, className, children }) => {
    return (
        <Slide direction="up" in={show} unmountOnExit timeout={TRANSITION_TIMEOUT}>
            <div className={className}>
                {children}
            </div>
        </Slide>);
}

export default TransitionSlide;